import { render, staticRenderFns } from "./certQuery.vue?vue&type=template&id=1063942d&scoped=true&"
import script from "./certQuery.vue?vue&type=script&lang=js&"
export * from "./certQuery.vue?vue&type=script&lang=js&"
import style0 from "./certQuery.vue?vue&type=style&index=0&id=1063942d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063942d",
  null
  
)

export default component.exports